export const LD_INITIALIZATION_TIMEOUT_SECONDS = 5

// Preserve the pre-rollout login flow whenever LaunchDarkly cannot resolve the flag.
// Both branches use Auth0 Universal Login; the flag only forces the passwordless email connection.
export const FORCE_EMAIL_CONNECTION_FALLBACK = false

export const getAuth0AuthorizationParams = ({ redirectUri, audience, forceEmailConnection }) => {
  const baseParams = {
    redirect_uri: redirectUri,
    audience,
    responseType: 'token refresh_token user_meta_data',
    scope: 'openid profile email read:users read:user_idp_token',
  }

  return forceEmailConnection ? { ...baseParams, connection: 'email' } : baseParams
}

export const getLaunchDarklyProviderConfig = (clientSideID) => ({
  clientSideID,
  user: {
    key: 'example_key',
  },
  // The SDK owns the initialization deadline and exposes the client after
  // ready, failure, or timeout. App startup does not need a second timer.
  timeout: LD_INITIALIZATION_TIMEOUT_SECONDS,
})

export const getForceEmailConnection = (ldClient) => {
  if (!ldClient) return null

  return (
    ldClient.variation(
      'auth0UniversalLogin',
      FORCE_EMAIL_CONNECTION_FALLBACK
    ) === true
  )
}
